import { Routes } from '@angular/router'

import { FeatureType, RouteGuard } from '../shared'
import { PurchasingDashboardComponent } from './dashboard/purchasing-dashboard.component'
import { PurchasingInvoicingComponent } from './invoicing/purchasing-invoicing.component'
import { PurchasingLayoutComponent } from './purchasing-layout/purchasing-layout.component'
import { PurchasingOrdersComponent } from './purchase-orders/purchasing-orders.component'
import { PurchasingQuotingComponent } from './quoting/purchasing-quoting.component'
import { PurchasingReconciliationComponent } from './reconciliation/purchasing-reconciliation.component'
import { PurchasingReceivingComponent } from './receiving/purchasing-receiving.component'

export const purchasingRoutes: Routes = [
    {
        path: 'purchasing',
        component: PurchasingLayoutComponent,
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: 'dashboard',
                component: PurchasingDashboardComponent,
                canActivate: [RouteGuard],
                data: { feature: FeatureType.PurchasingDashboardView },
            },
            {
                path: 'quoting',
                component: PurchasingQuotingComponent,
                canActivate: [RouteGuard],
                data: { feature: FeatureType.PurchasingQuotingView },
            },
            {
                path: 'purchase-orders',
                component: PurchasingOrdersComponent,
                canActivate: [RouteGuard],
                data: { feature: FeatureType.PurchasingPurchaseOrdersView },
            },
            {
                path: 'receiving',
                component: PurchasingReceivingComponent,
                canActivate: [RouteGuard],
                data: { feature: FeatureType.PurchasingReceivingView },
            },
            {
                path: 'invoicing',
                component: PurchasingInvoicingComponent,
                canActivate: [RouteGuard],
                data: { feature: FeatureType.PurchasingInvoicingView },
            },
            {
                path: 'reconciliation',
                component: PurchasingReconciliationComponent,
                canActivate: [RouteGuard],
                data: { feature: FeatureType.PurchasingReconciliationView },
            },
        ],
    },
]
